import type { ISerialize } from '@/objects/ISerialize';

export class ImportAdditionalValues implements ISerialize {
    public ISonenEventKey: string | null;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { ISonenEventKey?: string | null }) {
        this.ISonenEventKey = values.ISonenEventKey ?? null;
    }

    public serialize(): string {
        return '{' + `"ISonenEventKey": ${JSON.stringify(this.ISonenEventKey)}` + '}';
    }

    /**
     * Creates an instance of ImportAdditionalValues from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { ISonenEventKey?: string | null }): ImportAdditionalValues {
        return new ImportAdditionalValues(values);
    }

    public static _FromServerJson(json: any): ImportAdditionalValues {
        return new ImportAdditionalValues({ ISonenEventKey: json.ISonenEventKey ?? '' });
    }

    /**
     * Creates an instance of ImportAdditionalValues from another instance of ImportAdditionalValues.
     * @param other The ImportAdditionalValues you want to clone
     * @returns A cloned ImportAdditionalValues
     */
    public static FromOther(other: ImportAdditionalValues): ImportAdditionalValues {
        return ImportAdditionalValues._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return ImportAdditionalValues.FromOther(this);
    }

    static NAME_OF_CLASS = 'ImportAdditionalValues';
}
